<template>
  <div class="vue-podcast">
    <iframe
      class="podigee-podcast-player"
      :src="
        'https://cdn.podigee.com/podcast-player/podigee-podcast-player.html?configuration=' +
          podcast +
          '/embed?context=external'
      "
    ></iframe>
  </div>
</template>

<script>
export default {
  props: {
    podcast: String
  }
};
</script>

<style lang="scss">
.vue-podcast {
  padding: calc(0.5 * var(--lh)) 0;
  // border-bottom: var(--b) solid var(--color);
}
iframe {
  width: 100%;
  display: block;
}
</style>
